module.exports = __webpack_public_path__ + "static/media/delete-block.aee66e39.svg";